// Use the shared attachment viewer; it owns the preview URL and its cleanup.
export function createStatementAttachment(base64) {
  const binary = atob(base64);
  if (!binary.startsWith("%PDF-")) throw new Error("The statement PDF is invalid. Please try again.");
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  return {
    documentName: "Activity statement",
    documentFileName: "Activity-statement.pdf",
    file: new Blob([bytes], { type: "application/pdf" }),
  };
}
